import ArtifactGallery from "./ArtifactGallery";

export default ArtifactGallery;
